module.exports = __webpack_public_path__ + "img/chardan.4be72888.svg";